export default __webpack_public_path__ + "static/media/rfid_logo_lhtBlue.e7ed01b6.png";